import { all, call, put, select, takeEvery } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { UpdateAvatarI, UpdateInformationI, profileTypes } from "./profileTypes";
import { getUserInformationFailure, getUserInformationSuccess, updateAvatarFailure, updateAvatarSuccess, updateInformationFailure, updateInformationSuccess } from "./profileActions";
import { loginSuccess } from "../auth/authActions";
import ProfileService from "./service";
import { notify } from "../notification/notificationActions";
import { saveSecureStorage } from "../../utils/storage";

export function* getUserInformation(): SagaIterator {
  try {
    const { data } = yield call<typeof ProfileService.getUserInformation>(ProfileService.getUserInformation);
    const getUser = (state: any) => state.authReducer;
    const { user } = yield select(getUser);
    const updatedUser = {
      ...user,
      ...data,
    };

    saveSecureStorage(updatedUser, "user");
    yield put(getUserInformationSuccess(updatedUser));
    yield put(loginSuccess(updatedUser));
  } catch (error: any) {
    yield put(getUserInformationFailure(error?.message));
    yield put(notify({ message: error?.message, type: "error" }));
  }
}

export function* updateInformation({ payload, successCallback, failureCallback }: UpdateInformationI) {
  try {
    const { data } = yield call<typeof ProfileService.updateInformation>(ProfileService.updateInformation, payload);
    const getUser = (state: any) => state.authReducer;
    const { user } = yield select(getUser);
    const updatedUser = {
      ...user,
      ...data,
    };

    saveSecureStorage(updatedUser, "user");
    yield put(updateInformationSuccess(updatedUser));
    yield put(loginSuccess(updatedUser));
    yield call(successCallback);
  } catch (error: any) {
    yield put(updateInformationFailure(error?.message));
    yield call(failureCallback, error?.message);
  }
}

export function* updateAvatar({ payload, successCallback, failureCallback }: UpdateAvatarI): SagaIterator {
  try {
    const { data } = yield call<typeof ProfileService.updateAvatar>(ProfileService.updateAvatar, payload);
    const getUser = (state: any) => state.authReducer;
    const { user } = yield select(getUser);
    const updatedUser = {
      ...user,
      ...data,
    };

    saveSecureStorage(updatedUser, "user");
    yield put(updateAvatarSuccess(updatedUser));
    yield put(loginSuccess(updatedUser));
    if (successCallback) yield call(successCallback);
  } catch (error: any) {
    yield put(updateAvatarFailure(error?.message));
    if (failureCallback) yield call(failureCallback, error?.message);
  }
}

export function* onGetUserInformation() {
  yield takeEvery(profileTypes.GET_USER_INFORMATION, getUserInformation);
}

export function* onUpdateInformation() {
  yield takeEvery(profileTypes.UPDATE_INFORMATION, updateInformation);
}

export function* onUpdateAvatar() {
  yield takeEvery(profileTypes.UPDATE_AVATAR, updateAvatar);
}

export default function* profileSaga() {
  yield all([ call(onGetUserInformation), call(onUpdateInformation), call(onUpdateAvatar) ]);
}
